import React from 'react';

import ChartUnavailableNotice from 'views/playground/features/data-lab/components/charts/chart-unavailable-notice';

type Props = {
  height?: number;
};

// SankeyChart is Pro-only.
const MovementSankeyChart: React.FC<Props> = ({ height = 320 }) => {
  return (
    <ChartUnavailableNotice
      height={height}
      title="Fish movement — out of scope (license restricted)"
      description="Fish group movement between cages across the season on ribboned flows, once an @mui/x-charts-pro licence covers SankeyChart."
    />
  );
};

export default MovementSankeyChart;
